export const GET_PARCELS = 'src/pages/parcels/GET_PARCELS';
export const GET_PARCELS_SUCCESS = 'src/pages/parcels/GET_PARCELS_SUCCESS';
export const GET_PARCELS_FAILED = 'src/pages/parcels/GET_PARCELS_FAILED';
export const GET_PARCEL_INVENTORY_ITEMS =
  'src/pages/parcels/GET_PARCEL_INVENTORY_ITEMS';
export const GET_PARCEL_INVENTORY_ITEMS_SUCCESS =
  'src/pages/parcels/GET_PARCEL_INVENTORY_ITEMS_SUCCESS';
export const GET_PARCEL_INVENTORY_ITEMS_FAILED =
  'src/pages/parcels/GET_PARCEL_INVENTORY_ITEMS_FAILED';
export const CLEAN_PARCEL_INVENTORY_ITEMS =
  'src/pages/parcels/CLEAN_PARCEL_INVENTORY_ITEMS';

export const GET_ALL_PARCELS_REPORT = 'src/pages/parcels/GET_ALL_PARCELS_REPORT';
export const GET_ALL_PARCELS_REPORT_SUCCESS =
  'src/pages/parcels/GET_ALL_PARCELS_REPORT_SUCCESS';
export const GET_ALL_PARCELS_REPORT_FAILED =
  'src/pages/parcels/GET_ALL_PARCELS_REPORT_FAILED';


export const GET_INVENTORY_ITEMS_WITH_SERIAL =
  'src/pages/parcels/GET_INVENTORY_ITEMS_WITH_SERIAL';
export const GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS =
  'src/pages/parcels/GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS';
export const GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED =
  'src/pages/parcels/GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED';

export const GET_INVENTORY_ITEMS_WITH_STATUS =
  'src/pages/parcels/GET_INVENTORY_ITEMS_WITH_STATUS';
export const GET_INVENTORY_ITEMS_WITH_STATUS_SUCCESS =
  'src/pages/parcels/GET_INVENTORY_ITEMS_WITH_STATUS_SUCCESS';
export const GET_INVENTORY_ITEMS_WITH_STATUS_FAILED =
  'src/pages/parcels/GET_INVENTORY_ITEMS_WITH_STATUS_FAILED';

export const UPDATE_PARCELS = 'src/pages/parcels/UPDATE_PARCELS';
export const UPDATE_PARCELS_SUCCESS =
  'src/pages/parcels/UPDATE_PARCELS_SUCCESS';
export const UPDATE_PARCELS_FAILED = 'src/pages/parcels/UPDATE_PARCELS_FAILED';

export const UPDATE_INVENTORY_ITEMS =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS';
export const UPDATE_INVENTORY_ITEMS_SUCCESS =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_SUCCESS';
export const UPDATE_INVENTORY_ITEMS_FAILED =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_FAILED';

export const UPDATE_INVENTORY_ITEMS_CHECKED =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_CHECKED';
export const UPDATE_INVENTORY_ITEMS_CHECKED_SUCCESS =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_CHECKED_SUCCESS';
export const UPDATE_INVENTORY_ITEMS_CHECKED_FAILED =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_CHECKED_FAILED';

export const UPDATE_INVENTORY_ITEMS_UNIT =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_UNIT';
export const UPDATE_INVENTORY_ITEMS_UNIT_SUCCESS =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_UNIT_SUCCESS';
export const UPDATE_INVENTORY_ITEMS_UNIT_FAILED =
  'src/pages/parcels/UPDATE_INVENTORY_ITEMS_UNIT_FAILED';

export const UPDATE_ALL_INVENTORY_ITEMS_UNIT =
  'src/pages/parcels/UPDATE_ALL_INVENTORY_ITEMS_UNIT';
export const UPDATE_ALL_INVENTORY_ITEMS_UNIT_SUCCESS =
  'src/pages/parcels/UPDATE_ALL_INVENTORY_ITEMS_UNIT_SUCCESS';
export const UPDATE_ALL_INVENTORY_ITEMS_UNIT_FAILED =
  'src/pages/parcels/UPDATE_ALL_INVENTORY_ITEMS_UNIT_FAILED';

export const UPDATE_PARCEL_ITEMS_UNIT =
  'src/pages/parcels/UPDATE_PARCEL_ITEMS_UNIT';
export const UPDATE_PARCEL_ITEMS_UNIT_SUCCESS =
  'src/pages/parcels/UPDATE_PARCEL_ITEMS_UNIT_SUCCESS';
export const UPDATE_PARCEL_ITEMS_UNIT_FAILED =
  'src/pages/parcels/UPDATE_PARCEL_ITEMS_UNIT_FAILED';

export const CREATE_PARCEL_ITEMS =
  'src/pages/parcels/CREATE_PARCEL_ITEMS';
export const CREATE_PARCEL_ITEMS_SUCCESS =
  'src/pages/parcels/CREATE_PARCEL_ITEMS_SUCCESS';
export const CREATE_PARCEL_ITEMS_FAILED =
  'src/pages/parcels/CREATE_PARCEL_ITEMS_FAILED';

export const DELETE_PARCEL_ITEMS =
  'src/pages/parcels/DELETE_PARCEL_ITEMS';
export const DELETE_PARCEL_ITEMS_SUCCESS =
  'src/pages/parcels/DELETE_PARCEL_ITEMS_SUCCESS';
export const DELETE_PARCEL_ITEMS_FAILED =
  'src/pages/parcels/DELETE_PARCEL_ITEMS_FAILED';

export const UPDATE_PARCEL_OPERATOR =
  'src/pages/parcels/UPDATE_PARCEL_OPERATOR';
export const UPDATE_PARCEL_OPERATOR_SUCCESS =
  'src/pages/parcels/UPDATE_PARCEL_OPERATOR_SUCCESS';
export const UPDATE_PARCEL_OPERATOR_FAILED =
  'src/pages/parcels/UPDATE_PARCEL_OPERATOR_FAILED';

export const CREATE_PARCELS = 'src/pages/parcels/CREATE_PARCELS';
export const CREATE_PARCELS_SUCCESS =
  'src/pages/parcels/CREATE_PARCELS_SUCCESS';
export const CREATE_PARCELS_FAILED = 'src/pages/parcels/CREATE_PARCELS_FAILED';

export const CREATE_GROUPING_PARCELS = 'src/pages/parcels/CREATE_GROUPING_PARCELS';
export const CREATE_GROUPING_PARCELS_SUCCESS =
  'src/pages/parcels/CREATE_GROUPING_PARCELS_SUCCESS';
export const CREATE_GROUPING_PARCELS_FAILED = 'src/pages/parcels/CREATE_GROUPING_PARCELS_FAILED';

export const UPDATE_PARCELS_STATUS = 'src/pages/parcels/UPDATE_PARCELS_STATUS';
export const UPDATE_PARCELS_STATUS_SUCCESS =
  'src/pages/parcels/UPDATE_PARCELS_STATUS_SUCCESS';
export const UPDATE_PARCELS_STATUS_FAILED =
  'src/pages/parcels/UPDATE_PARCELS_STATUS_FAILED';

export const GET_PARCELS_WITH_ID = 'src/pages/parcels/GET_PARCELS_WITH_ID';
export const GET_PARCELS_WITH_ID_SUCCESS =
  'src/pages/parcels/GET_PARCELS_WITH_ID_SUCCESS';
export const GET_PARCELS_WITH_ID_FAILED =
  'src/pages/parcels/GET_PARCELS_WITH_ID_FAILED';

  export const GET_RONAD_PARCELS_WITH_ID = 'src/pages/parcels/GET_RONAD_PARCELS_WITH_ID';
  export const GET_RONAD_PARCELS_WITH_ID_SUCCESS = 'src/pages/parcels/GET_RONAD_PARCELS_WITH_ID_SUCCESS';
  export const GET_RONAD_PARCELS_WITH_ID_FAILED = 'src/pages/parcels/GET_RONAD_PARCELS_WITH_ID_FAILED';

export const DELETE_PARCEL = 'src/pages/parcels/DELETE_PARCEL';
export const DELETE_PARCEL_SUCCESS = 'src/pages/parcels/DELETE_PARCEL_SUCCESS';
export const DELETE_PARCEL_FAILED = 'src/pages/parcels/DELETE_PARCEL_FAILED';

export const CANCEL_PARCEL = 'src/pages/parcels/CANCEL_PARCEL';
export const CANCEL_PARCEL_SUCCESS = 'src/pages/parcels/CANCEL_PARCEL_SUCCESS';
export const CANCEL_PARCEL_FAILED = 'src/pages/parcels/CANCEL_PARCEL_FAILED';

export const GET_LOGS = 'src/pages/parcels/GET_LOGS';
export const GET_LOGS_SUCCESS = 'src/pages/parcels/GET_LOGS_SUCCESS';
export const GET_LOGS_FAILED = 'src/pages/parcels/GET_LOGS_FAILED';

export const RELOCATE_BY_ITEM = 'src/pages/parcels/RELOCATE_BY_ITEM';
export const RELOCATE_BY_ITEM_SUCCESS =
  'src/pages/parcels/RELOCATE_BY_ITEM_SUCCESS';
export const RELOCATE_BY_ITEM_FAILED =
  'src/pages/parcels/RELOCATE_BY_ITEM_FAILED';

export const UPDATE_MULTI_INVENTORY_ITEMS_STATUS =
  'src/pages/parcels/UPDATE_MULTI_INVENTORY_ITEMS_STATUS';
export const UPDATE_MULTI_INVENTORY_ITEMS_STATUS_SUCCESS =
  'src/pages/parcels/UPDATE_MULTI_INVENTORY_ITEMS_STATUS_SUCCESS';
export const UPDATE_MULTI_INVENTORY_ITEMS_STATUS_FAILED =
  'src/pages/parcels/UPDATE_MULTI_INVENTORY_ITEMS_STATUS_FAILED';
